const ENEMY_TYPE = {
  Ghost: 'GHOST',
  EvilPumpkin: 'EVIL_PUMPKIN',
  Skeleton: 'SKELETON',
}

const ENEMY_STATE = {
  Idle: 'IDLE',
  Active: 'ACTIVE',
}

export { ENEMY_TYPE, ENEMY_STATE };
